/*****************************************
 **** Product page: Place Shogun Root
 ******************************************/

function placeShogunContentProductPage() {
  const shogunContentProductPage = document.querySelector(
    "body.page-product div.shopify-section[id*='shogun-below'] div.shogun-root"
  )
  const reviewsSection = document.querySelector(".page-product #judgeme_product_reviews")

  if (shogunContentProductPage && reviewsSection) {
    const reviewsParent = reviewsSection.closest(".shopify-section")
    const shogunContentParent = shogunContentProductPage.closest(".shopify-section")

    if (reviewsParent && shogunContentParent) {
      reviewsParent.parentNode.insertBefore(shogunContentParent, reviewsParent)
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  placeShogunContentProductPage()
})
